<template>
  <div class="app-logo">
    <img class="app-logo__bg" src="/img/logo/bg.png" alt="Background Gucci logo">

    <img class="app-logo__flower app-logo__flower--top" src="/img/logo/flower-top.png" alt="Flower Gucci bloom">
    <img class="app-logo__flower app-logo__flower--left" src="/img/logo/flower-left.png" alt="Flower Gucci bloom">
    <img class="app-logo__flower app-logo__flower--right" src="/img/logo/flower-right.png" alt="Flower Gucci bloom">

    <strong>
      <img class="app-logo__gucci" src="/img/logo/gucci-bloom-logo.svg" alt="Gucci bloom logo">
    </strong>
  </div>
</template>

<script>
export default {
  name: 'AppLogo',
};
</script>

<style lang="scss" scoped>
.app-logo {
  display: inline-block;
  position: relative;

  &__bg {
    display: block;
    position: relative;
    width: 15vw;
    min-width: 180px;
    max-width: 300px;
    height: auto;

    @include mq($from: ipadP, $and: $is-portrait) {
      width: 24vw;
    }
  }

  &__flower {
    position: absolute;

    &.app-logo__flower--top {
      width: 30%;
      top: -14%;
      left: 50%;
      margin-left: -15%;
    }
    &.app-logo__flower--left,
    &.app-logo__flower--right {
      width: 25%;
      top: 15%;
    }
    &.app-logo__flower--left {
      left: -3%;
    }
    &.app-logo__flower--right {
      right: -3%;
    }
  }

  strong {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 54.2%;

    transform: translateX(-50%) translateY(-50%);

    .app-logo__gucci {
      width: 100%;
    }
  }
}
</style>
